import { render, staticRenderFns } from "./Taurus.vue?vue&type=template&id=e7c24480&"
import script from "./Taurus.vue?vue&type=script&lang=js&"
export * from "./Taurus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports